/**
 * /privacy — Compliance Baseline v1.0 (STA-128, STA-129).
 *
 * Mirrors `docs/product/compliance/legal/v1.0/privacy-policy.md`.
 */

import { LegalPage, Section } from '../components/LegalPage';

export default function Privacy() {
  return (
    <LegalPage title="隱私權政策" version="v1.0" lastUpdated="2026-05-14">
      <Section title="總則">
        <p>
          Starstwinkling（下稱「本站」）重視您的隱私權。本政策說明我們如何蒐集、處理、利用及保護您的個人資料，並依《<strong>個人資料保護法</strong>》（下稱「個資法」）相關規定辦理。
        </p>
      </Section>

      <Section title="第 1 條　蒐集之個人資料類別">
        <ul>
          <li><strong>C001 識別類</strong>：電子郵件、暱稱（註冊）</li>
          <li><strong>C011 個人描述</strong>：出生年（用於確認 18 歲，註冊）</li>
          <li><strong>C036 生活方式</strong>：占卜提問內容（使用服務時）</li>
          <li><strong>C081 信用卡帳號</strong>：由第三方金流處理，本站不直接儲存完整卡號</li>
          <li><strong>技術紀錄</strong>：IP 位址、瀏覽器資訊、Cookie</li>
        </ul>
      </Section>

      <Section title="第 2 條　蒐集目的">
        <ul>
          <li>001 提供服務：建立帳號、執行占卜、儲存歷史紀錄</li>
          <li>069 契約履行：付費訂單管理與爭議處理</li>
          <li>090 消費爭議處理：依法保存交易與同意紀錄</li>
          <li>136 資訊服務：服務品質改善、AI 解讀模型優化（僅以<strong>去識別化後資料</strong>為之）</li>
          <li>152 廣告或商業行為管理：經您另行同意之行銷溝通</li>
        </ul>
      </Section>

      <Section title="第 3 條　資料利用期間、地區、對象及方式">
        <ul>
          <li><strong>期間</strong>：自您同意之日起至您要求刪除帳號後 6 個月（保留期係供法定爭議處理）</li>
          <li><strong>地區</strong>：中華民國（資料儲存於台灣 / 美國之雲端服務商）</li>
          <li><strong>對象</strong>：本站、本站委外之雲端服務商、金流服務商（綠界 / 藍新）、依法有權之機關</li>
          <li><strong>方式</strong>：電子檔案儲存、必要時透過加密通訊傳輸</li>
        </ul>
      </Section>

      <Section title="第 4 條　提問內容之特別保護">
        <p>
          您於本站輸入之占卜提問內容，<strong>屬高度敏感之個人困擾與想法</strong>，本站採以下措施保護：
        </p>
        <ul>
          <li><strong>儲存加密</strong>：提問原文於資料庫中以 AES-256 加密儲存，金鑰獨立管理。</li>
          <li><strong>去識別化</strong>：用於 AI 解讀模型運算之向量資料庫（Vector DB）<strong>僅儲存無關個資之 metadata</strong>（如語言、牌陣類型、內部 UUID），不含您的姓名、Email、IP 或可識別之原文。</li>
          <li><strong>使用範圍</strong>：僅用於本次解讀計算與您本人之歷史紀錄展示，<strong>不會用於行銷或外部分享</strong>。</li>
          <li><strong>第三方 AI</strong>：當解讀計算需呼叫第三方 LLM（如 OpenAI / Anthropic）時，僅傳送去識別化後之內容片段，並依各服務商之資料政策辦理。</li>
        </ul>
      </Section>

      <Section title="第 5 條　Cookie 與類似技術">
        <ul>
          <li>本站使用必要 Cookie 維持登入狀態與功能運作。</li>
          <li>使用分析型 Cookie（如 Google Analytics）瞭解整體使用情形（已匿名化）。</li>
          <li>您可於瀏覽器設定中拒絕 Cookie，但部分功能可能受影響。</li>
        </ul>
      </Section>

      <Section title="第 6 條　您的權利">
        <p>依個資法第 3 條，您就本站持有之您的個人資料，得行使下列權利：</p>
        <ul>
          <li>查詢或請求閱覽</li>
          <li>請求製給複製本</li>
          <li>請求補充或更正</li>
          <li>請求停止蒐集、處理或利用</li>
          <li>請求刪除</li>
        </ul>
        <p>行使方式：來信 support@starstwinkling.com，本站將於收信後 30 日內回覆。</p>
      </Section>

      <Section title="第 7 條　資料安全措施">
        <ul>
          <li>全站採用 HTTPS / TLS 加密傳輸</li>
          <li>密碼以 bcrypt / Argon2 雜湊儲存，本站員工亦無法還原</li>
          <li>敏感欄位於資料庫採欄位級加密</li>
          <li>雲端服務商皆通過 SOC 2 或同等標準之認證</li>
          <li>定期備份並執行漏洞掃描</li>
        </ul>
        <p>
          雖採取上述措施，網路傳輸仍存在不可預期之風險，<strong>本站無法擔保 100% 安全</strong>。如發生個資外洩事件，將依個資法第 12 條於知悉後即時以適當方式通知您。
        </p>
      </Section>

      <Section title="第 8 條　未成年人資料">
        <p>本站僅服務滿 18 歲之使用者。若您未滿 18 歲，請勿提供個人資料；若本站發現誤蒐集未成年人資料，將立即刪除。</p>
      </Section>

      <Section title="第 9 條　政策修訂">
        <ul>
          <li>本政策得隨時修訂，修訂後於本站公告並更新版本號與生效日期。</li>
          <li>重大變更將於生效前 7 日以 Email 或站內信通知。</li>
          <li>您於變更後繼續使用，視為同意變更後之政策。</li>
        </ul>
      </Section>

      <Section title="第 10 條　聯絡方式">
        <p>📧 個資權利行使、隱私疑問：support@starstwinkling.com</p>
      </Section>
    </LegalPage>
  );
}
